
import { Component, Prop, Vue } from 'vue-property-decorator';
import { form8DataInfoType } from '@/types/Information/Form8';

import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";

@Component({
    components:{       
        CheckBox           
    }
})
export default class Form8Layout extends Vue {

    @Prop({required:true})
    result!: form8DataInfoType;

    judgeName='';
    dataReady = false;

    mounted(){
        this.extractInfo();       
        this.dataReady = true;
    }

    public extractInfo(){ 
        this.judgeName = this.result.judgeName=='Other'? this.result.judgeNameOther :this.result.judgeName;        
    }

}

